import NavBar from '../components/linkTrees/home/linktreeList/navbar/main';
import Body from '../components/linkTrees/home/linktreeList/body/main';

export default function LinkTree(){
    return(
        <div>
            <NavBar/>
            <Body/>
        </div>
    )
}